import { Box } from "@mui/material";
import { useMemo } from "react";
import Tile from "./Tile";
import TileUsage from "./TileUsage";
import TileUsers from "./TileUsers";

export default function Overview() {
  const tileTrial = useMemo(
    () => (
      <Tile
        type={["TRIAL"]}
        sortBy={"creationTime"}
        title={"Trials"}
        chartTitle={"Acquisitions"}
      />
    ),
    []
  );
  const tileSubscribers = useMemo(
    () => (
      <Tile
        type={["SUBSCRIBER"]}
        sortBy={"levelUpdate"}
        title={"Subscribers"}
        chartTitle={"conversions"}
      />
    ),
    []
  );
  return (
    <Box
      position={"relative"}
      py={1}
      px={2}
      gap={1}
      height={"100%"}
      overflow={"hidden"}
      flexDirection={"column"}
      display={"flex"}
      width={"100%"}
    >
      <Box
        maxHeight={"33.3%"}
        height={"100%"}
        minHeight={0}
        gap={1}
        width={"100%"}
        display={"flex"}
      >
        <Box
          width={"50%"}
          borderRadius={2}
          boxShadow={3}
          height={"100%"}
          overflow={"hidden"}
        >
          {tileTrial}
        </Box>

        <Box
          width={"50%"}
          borderRadius={2}
          boxShadow={3}
          height={"100%"}
          overflow={"hidden"}
        >
          {tileSubscribers}
        </Box>
      </Box>
      <Box sx={{ height: "40%", minHeight: 0 }}>
        <Box
          height={"100%"}
          minHeight={0}
          display={"flex"}
          gap={1}
          position={"relative"}
        >
          <Box
            borderRadius={2}
            boxShadow={3}
            minHeight={0}
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
            width={"100%"}
            overflow={"hidden"}
          >
            <TileUsage type={["SUBSCRIBER", "TRIAL"]} />
          </Box>
        </Box>
      </Box>
      <Box sx={{ height: "20%", minHeight: 0 }}>
        <Box
          height={"100%"}
          minHeight={0}
          display={"flex"}
          gap={1}
          position={"relative"}
        >
          <Box
            borderRadius={2}
            boxShadow={3}
            display={"flex"}
            minHeight={0}
            flex={1}
            height={"100%"}
            overflow={"hidden"}
          >
            <TileUsers />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
